module.exports = __webpack_public_path__ + "static/media/Sophia.a46bb65a.png";